<template>
  <div class="row">
    <div class="sixty">
      <div class="envn" style="margin-left:10px">
      <h2>So here's the deal</h2>
      <p>We need your help to create something that will implement effective change, increase ROI, and make your team more awesome than they already are.</p>

      <p>You'll get to understand how your services actually work versus you think they work!</p>

      <div id="pricing">
        <h3>We'll bill you <strong>€20 <span>per month</span></strong></h3>
        <dl>
          <dt>For that you'll get</dt>
          <dd>Up to 5 team members</dd>
          <dd>Unlimited services</dd>
          <dd>Unlimited architecture decisions</dd>
          <dd>Making your teams look more awesome!</dd>
        </dl>
      </div>

      </div>
    </div>
    <div class="thirty" style="margin-left:auto; background-color:#fff">
      <div style="padding:10px;">
        <div v-show="isSaving">
          <progress-ring radius="60" :progress="progress" stroke="4"></progress-ring>
        </div>

        <div v-show="!isSaving">
        <h2>Sign up</h2>
        <div v-show="signupError">
          <h2>Looks like something broke!</h2>
          <p>{{ signupErrorMessage }}</p>
        </div>
        <form>
        <p>
        <label for="email">email</label>
        <input v-model="account.email" type="email" autocomplete="email" id="email" required>
        </p>
        <p>
        <label for="name">name</label>
        <input v-model="account.name" type="name" autocomplete="name" id="name" required>
        </p>
        <p>
        <label for="organisation">Your Organisation</label>
        <input v-model="organisation.name" type="text" autocomplete="organization" id="organisation" required>
        </p>
        <p>
        <label for="password">password</label>
        <input v-model="account.password" type="password" autocomplete="new-password" id="password" required>
        </p>
        <div class="row">
          <div class="fifty">
            <p>
              <label>
                 You're ok with our Privacy Policy <br>
              <toggle-button v-model="account.privacy" :labels="{checked: 'Yes', unchecked: 'No'}" :color="{checked: '#78C0A8', unchecked: '#FF0000', disabled: '#CCCCCC'}" />
              </label>
            </p>
          </div>
          <div class="fifty">
            <p>
              <label>
                 You're ok with our Terms and Conditions <br>
              <toggle-button v-model="account.terms" :labels="{checked: 'Yes', unchecked: 'No'}" :color="{checked: '#78C0A8', unchecked: '#FF0000', disabled: '#CCCCCC'}" />
              </label>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="fifty">
            <router-link to="/sign-in"><small>Already have an account? <br>Sign in</small></router-link>
          </div>
          <div class="fifty">
            <input type="button" value="Sign up!" style="margin-right:20px" @click="createAccount()">
          </div>
        </div>
        </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/services/repositoryfactory'
import { ToggleButton } from 'vue-js-toggle-button';
import { Auth, Analytics } from 'aws-amplify'
import ProgressRing from '@/components/progress-ring.vue'
import uuidv4 from 'uuid/v4'
const OrgRepository = RepositoryFactory.get('organisation');

export default {
  name: 'sign-up',
  components: {
    ToggleButton,
    ProgressRing
  },
  data: () => ({
      signupError: false,
      isSaving: false,
      signupErrorMessage: "",
      progress: 10,
      account: {
        email: "",
        name: "",
        password: "",
        privacy: false,
        terms: false
      },
      organisation: {
        name: "",
        id: uuidv4()
      },
      loginError: false
  }),
  mounted() {
    let stripeScript = document.createElement('script')
    stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
    document.head.appendChild(stripeScript);

    (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:2330268,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  },
  methods: {
    createProfile: async function () {
      var created_on = Date.now().toString();
      var agreed_on = this.getNow();
      try {
        await Auth.signUp({
          'username': this.account.email,
          'password': this.account.password,
          attributes: {
            'email': this.account.email,
            'name': this.account.name,
            'updated_at': created_on,
            'custom:orgId': this.organisation.id,
            'custom:org': this.organisation.name,
            'custom:privacy': this.account.privacy.toString().toUpperCase(),
            'custom:privacy_agreed': agreed_on,
            'custom:terms': this.account.terms.toString().toUpperCase(),
            'custom:terms_agreed': agreed_on
          },
        });
        this.progress += 30;
      } catch (error){
        this.signupError = true;
        // bring the form back
        this.isSaving = false;
        // Swing back to the user account screen...
        this.sendAnalyticsEvent("signup-screen-error");
        this.signupErrorMessage = error.message;
      }
    },

    getNow() {
      var date = new Date();
      var aaaa = date.getUTCFullYear();
      var gg = date.getUTCDate();
      var mm = (date.getUTCMonth() + 1);

      if (gg < 10) {
         gg = "0" + gg;
      }

      if (mm < 10) {
         mm = "0" + mm;
      }

      var cur_day = aaaa + "-" + mm + "-" + gg;
      var hours = date.getUTCHours()
      var minutes = date.getUTCMinutes()
      var seconds = date.getUTCSeconds();

      if (hours < 10) {
         hours = "0" + hours;
      }
      if (minutes < 10) {
         minutes = "0" + minutes;
      }
      if (seconds < 10) {
         seconds = "0" + seconds;
      }
      return cur_day + " " + hours + ":" + minutes + ":" + seconds +" UTC";
    },

    signInUser: async function() {
      // give Lambda a sec to confirm the user
      setTimeout(function() { return true; }, 1000);

      try {
        await Auth.signIn(this.account.email, this.account.password);
        this.progress += 30;
      } catch (error) {
        this.signupError = true;
        this.signupErrorMessage = "There was an error signing-in";
      }
    },

    createOrganisation: async function () {
      if(this.signupError == false) {
        return await OrgRepository.create(this.organisation)
                      .catch(error => {
                        console.log(error);
                        this.sendAnalyticsEvent("signup-screen-org-error");
                        this.signupError = true;
                        this.signupErrorMessage = "There was an error with the API";
                        throw "error";
                      });
      } else {
        this.sendAnalyticsEvent("signup-screen-org-error");
        this.isSaving = false;
        this.signupError = true;
        this.signupErrorMessage = "There was an error with the API";
        throw "error";
      }
    },

    sendAnalyticsEvent(eventName) {
      Analytics.record({
          name: "signup",
          attributes: {
              screen: eventName
          }
      });
    },

    createAccount: async function() {
      this.isSaving = true;

      var stripeSession;
      await this.createProfile();
      await this.signInUser();


      await this.createOrganisation().then(response => {
        stripeSession = response.session;
        this.progress += 30;
      })
      .catch(error => {
        console.log(error);
        this.signupError = true;
        this.isSaving = false;
      });

      if(this.signupError == false && stripeSession) {
        this.sendAnalyticsEvent("signup-screen-completed");
        var stripe = Stripe(process.env.VUE_APP_STRIPE);

        stripe.redirectToCheckout({
            sessionId: stripeSession
        })
      }
    }
  }
}
</script>
